import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MainNav1 from "./MainNav1";
import MainNav2 from "./MainNav2";

export interface HeaderProps {
  navType?: "MainNav1" | "MainNav2";
  className?: string;
}

const Header: FC<HeaderProps> = ({ navType = "MainNav1", className = "" }) => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isTransparent = isHome && !scrolled;
  const isDark = isTransparent || (isHome && scrolled);

  const renderNav = () => {
    switch (navType) {
      case "MainNav2":
        return <MainNav2 />;
      default:
        return <MainNav1 isDark={isDark} />;
    }
  };

  let headerBg = "";
  if (isTransparent) {
    headerBg =
      "fixed top-0 bg-transparent border-b border-transparent";
  } else if (isHome) {
    headerBg =
      "sticky top-0 bg-[#0f1b3d]/97 backdrop-blur-md border-b border-white/10 shadow-lg";
  } else if (scrolled) {
    headerBg =
      "sticky top-0 bg-white dark:bg-neutral-900 border-b border-neutral-100 dark:border-neutral-800";
  } else {
    headerBg =
      "sticky top-0 bg-white dark:bg-neutral-900 border-b border-neutral-100 dark:border-neutral-800";
  }

  return (
    <div
      className={`nc-Header w-full left-0 right-0 z-50 transition-all duration-300 ${headerBg} ${className}`}
    >
      {renderNav()}
    </div>
  );
};

export default Header;
